import { render } from "./EnhancedTextarea.vue?vue&type=template&id=42758e32"
import script from "./EnhancedTextarea.vue?vue&type=script&lang=js"
export * from "./EnhancedTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/EnhancedTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42758e32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42758e32', __exports__)) {
    api.reload('42758e32', __exports__)
  }
  
  module.hot.accept("./EnhancedTextarea.vue?vue&type=template&id=42758e32", () => {
    api.rerender('42758e32', render)
  })

}


export default __exports__